import { Bouncer } from "./Bouncer.js";
export async function loadExternalBounceInteraction(engine, refresh = true) {
    await engine.addInteractor("externalBounce", (container) => new Bouncer(container), refresh);
}
export * from "./Options/Classes/Bounce.js";
export * from "./Options/Interfaces/IBounce.js";
